'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
exports.toBech32 = void 0;
var _bech = require('bech32');
var toBech32 = (exports.toBech32 = function toBech32(address) {
	if (!address.length) {
		throw new Error('Invalid address length');
	}
	var words = _bech.bech32.toWords(address);
	return _bech.bech32.encode('sei', words);
});
//# sourceMappingURL=bech32.js.map
